$(document).ready(() => {
  if ($('.choices__list [role=option]').length > 0) {
    $('.choices__list [role=option]').each((i, el) => {
      if (el.hasAttribute('aria-label') === false) {
        el.setAttribute('aria-label', el.textContent);
      }
      if (el.hasAttribute('aria-selected') === false) {
        el.setAttribute('aria-selected', 'false');
      }
    });
  }
});
